export default __webpack_public_path__ + "static/media/Dr.-Harsha-MD-FRGUHS-Dermatosurgery.12042c18.jpg";